<div class="claim-details">
    <p-dialog [modal]="true" [closable]="false" [(visible)]="showRecallModal" styleClass="mx-3 col-5"
        [style]="{width: 'min(31.5rem, 92vw)'}">
        <ng-template #header>
            <div class="flex align-items-center justify-content-center relative w-full">
                <span class="text-slate-800 text-sm sm:text-base custom-bold">Request service again</span>
                <p-button icon="pi pi-times" class="absolute right-0" [rounded]="true" severity="secondary"
                    [outlined]="true" (click)="closeRecallDialog()" />
            </div>
        </ng-template>
        <p-divider styleClass="my-0"></p-divider>
        <div class="px-3 pb-4 text-sm sm:text-base">
            <p *ngIf="recallErrorPhone" class="my-5">Unfortunately, we are unable to book your return service at the
                moment. Please contact Customer
                Service at
                <span [innerHTML]="recallErrorPhone | phone:true" appGaButtonClick [buttonLocation]="location"
                    [buttonName]="recallErrorPhoneNumber"></span>
                to schedule your appointment.
            </p>
            <ng-container *ngIf="!isAPOSPCompletedJob">
                <p class="mt-5 p-1 line-height-3">Your previous repair may still be covered under the 180-day
                    workmanship guarantee - if your technician determines it's a <strong>different issue, a separate request
                        and deductible will apply.</strong></p>

                <div class="shadow-button bg-slate-50 flex align-items-center justify-content-start gap-3 mb-4 p-2 w-full border-round-md border-slate-200 border-solid"
                    *ngIf="selectedJob?.models?.length">
                    <div class="flex-shrink-0">
                        <cinch-icon class="w-3rem h-3rem flex bg-emerald-50 border-emerald-100 border-1 border-round-sm"
                            [icon]="getIcon(selectedJob!.models[0].itemId)" theme="quaternary"></cinch-icon>
                    </div>
                    <div class="flex flex-column align-items-start text-left w-full">
                        <p class="m-0 mb-1 text-slate-950 font-medium">
                            {{selectedJob!.models[0].itemName}}
                        </p>
                        <p *ngIf="getSymptomDesc(selectedJob) as symptom" data-auto-id="description-text"
                            class="m-0 text-slate-950 font-medium">
                            Symptom: {{symptom | capitalizeFirst}}</p>
                    </div>
                </div>


                <p class="text-slate-950 custom-bold">Is this the same item and issue?</p>
                <div class="flex flex-column gap-3 align-items-center justify-content-center">
                    <p-button [label]="isLoading ? '' : 'Yes, schedule a recall service'" [rounded]="true"
                        severity="primary" class="w-full" styleClass="w-full text-sm sm:text-base shadow-button"
                        [disabled]="isLoading" (click)="scheduleRecallService()">
                        <ng-container *ngIf="isLoading">
                            <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>&nbsp;Please wait
                        </ng-container>
                    </p-button>
                    <p-button [rounded]="true" severity="secondary" variant="outlined"
                        [label]="isDifferentIssueLoading ? '' : 'No different issue, start a new request'" class="w-full"
                        styleClass="w-full text-sm sm:text-base shadow-button"
                        [disabled]="isLoading || isDifferentIssueLoading" (click)="RedirectToWhatIsIssue()">
                        <ng-container *ngIf="isDifferentIssueLoading">
                            <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>&nbsp;Please wait
                        </ng-container>
                    </p-button>
                </div>
            </ng-container>
        </div>
    </p-dialog>
</div>